module.exports = __webpack_public_path__ + "media/svg/neutral_dark_vertical-b0124cd6.svg";